import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './editReport.css';
import { updateMRSItesReports, getNotesforReports } from '../../../apiServices';
import { saveMRGroupsMstrInsert, getgridHeaders } from '../../../apiServices/reducer/apiService';
import { useDispatch, useSelector } from 'react-redux';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/material_green.css';
import { Calendar, X } from "react-feather";


// Helper to safely parse date strings or Date objects
const parseDate = (dateInput) => {
    if (!dateInput) return null;
    if (dateInput instanceof Date) return dateInput;
    try {
        const date = new Date(dateInput);
        // Check if the date is valid after parsing
        return isNaN(date.getTime()) ? null : date;
    } catch (e) {
        return null;
    }
};

// Helper to format date with forward slashes (MM/DD/YYYY)
const formatDateWithSlashes = (date) => {
    if (!date) return '';
    if (typeof date === 'string') {
        date = new Date(date);
    }
    if (date instanceof Date && !isNaN(date.getTime())) {
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    }
    return '';
};

function EditReportModal({
    show,
    onHide,
    reportData = {},
    onSave,
    selectedFamilyMember,

}) {
    // --- State ---
    const [reportName, setReportName] = useState('');
    const [selectedGroupId, setSelectedGroupId] = useState('');
    const [category, setCategory] = useState('');
    const [providerName, setProviderName] = useState('');
    const [hospitalName, setHospitalName] = useState('');
    const [reportDate, setReportDate] = useState(null);
    const [isAddingNewGroup, setIsAddingNewGroup] = useState(false);
    const [newGroupName, setNewGroupName] = useState('');
    const [isSaving, setIsSaving] = useState(false);
    const [saveError, setSaveError] = useState('');
    const [groupsLst, setGroupsLst] = useState([]);

    const token = useSelector((state) => state.apiService.token);
    const userData = useSelector((state) => state.apiService.login);
    const selectedFamilyMemberFromStore = useSelector((state) => state.apiService.selectedFamilyMember);

    // Resolve the effective user whose report is being edited.
    // Prefer the family member passed via props, then the one in the redux store, then the logged-in user.
    const effectiveUserId =
        selectedFamilyMember?.user_id ||
        selectedFamilyMemberFromStore?.user_id ||
        userData?.user_id;

    // Field-specific error states
    const [errors, setErrors] = useState({
        reportName: '',
        category: '',
        newGroupName: '',
        providerName: '',
        hospitalName: '',
        reportDate: ''
    });
    const dispatch = useDispatch();


    const addNewGroup = async () => {
        if (newGroupName) {
            try {
                setIsSaving(true);
                setSaveError('');
                dispatch(saveMRGroupsMstrInsert({
                    GroupName: newGroupName,
                    UserID: effectiveUserId,
                    token: token
                })).then((res) => {
                    console.log("res for add new group", res)
                    setGroupsLst([])
                    setIsAddingNewGroup(false);
                    setNewGroupName('');
                    clearFieldError('newGroupName');
                    getReportTypes();
                    setIsSaving(false); // Reset saving state after successful API call
                }).catch((err) => {
                    console.log("err", err)
                    setIsSaving(false); // Reset saving state on error
                })
            } catch (error) {
                setSaveError(error.message || "Failed to add new group");
                setIsSaving(false); // Reset saving state on error
            }
        }
    }


    // --- Effects ---
    useEffect(() => {
        console.log("show", groupsLst)
        console.log(reportData, "reportData")
        console.log("EditReport effectiveUserId:", effectiveUserId, "selectedFamilyMember:", selectedFamilyMember)

        if (show && reportData) {
            setReportName(reportData.edit_report_name || '');

            // Find the group ID that matches the reportData.category name
            if (reportData.category||reportData.group_name) {
                getReportTypes();

            }else{
                setCategory('');
            }

            setProviderName(reportData.provider_name || '');
            setHospitalName(reportData.clinic || '');
            const parsedDate = parseDate(reportData.date);
            setReportDate(parsedDate);
            console.log("reportData formatted date:", formatDateWithSlashes(parsedDate))
            setIsAddingNewGroup(false);
            setNewGroupName('');
            setSaveError('');
            // Clear all field errors
            setErrors({
                reportName: '',
                category: '',
                newGroupName: '',
                providerName: '',
                hospitalName: '',
                reportDate: ''
            });
        }
    }, [reportData, selectedFamilyMember?.user_id]);

    // Helper function to clear specific field error
    const clearFieldError = (field) => {
        setErrors(prev => ({
            ...prev,
            [field]: ''
        }));
    };

    const getReportTypes = async () => {
        dispatch(getgridHeaders({
            user_id: effectiveUserId,
            token: token
        })).then((res) => {
            console.log("res for get report types", res)

            const formattedDataforGroupList = (res.payload || [])
                .filter((report) => String(report?.name ?? '').trim().toLowerCase() !== 'all')
                .map((report) => ({
                    category: report.name,
                    id: report.id
                }));
            setGroupsLst(formattedDataforGroupList);
            const reportGroupName =
                reportData?.category ?? reportData?.group_name ?? reportData?.groupName ?? '';

            if (reportGroupName) {
                console.log("reportData.category", reportGroupName)
                const matchingGroup = formattedDataforGroupList.find(
                    (group) => group.category === reportGroupName
                );
                console.log("matchingGroup", matchingGroup)
                setCategory(matchingGroup ? matchingGroup.id : '');
                console.log("category", category)
            }else{
                setCategory('');
            }
        })
    }

    const handleInputChange = (field, value) => {
        console.log("handleInputChange", field, value)
        switch (field) {
            case 'report_name':
                setReportName(value);
                clearFieldError('reportName');
                break;
            case 'group_name':
                setCategory(value);
                clearFieldError('category');
                break;
            case 'provider_name':
                setProviderName(value);
                clearFieldError('providerName');
                break;
            case 'hospital_name':
                setHospitalName(value);
                clearFieldError('hospitalName');
                break;
            case 'report_date':
                const parsedDate = parseDate(value);
                console.log("formattedDate with slashes:", formatDateWithSlashes(parsedDate))
                setReportDate(parsedDate);
                clearFieldError('reportDate');
                break;
            default:
                break;
        }
    };

    const handleSaveChanges = async () => {
        if (isSaving) return;
        console.log("reportDate", reportDate)
        const formattedDate = reportDate ? reportDate.toISOString().split('T')[0].replace("-", "/") : null;
        console.log("formattedDate", formattedDate)

        const editedData = {
            ReportID: reportData?.reportId,
            ReportName: reportName.trim(),
            // LoginUserID is who is performing the edit (always the logged-in user).
            // UserID is the owner of the report — if a family member is selected, it must be that member's id.
            LoginUserID: userData?.user_id,
            token: token,
            UserID: effectiveUserId,
            GroupID: isAddingNewGroup ? null : category,
            HospitalName: hospitalName.trim(),
            ProviderName: providerName.trim(),
            ReportDate: formatDateWithSlashes(reportDate),


        };

        console.log("Saving report with formatted date:", formatDateWithSlashes(reportDate));

        // Clear all previous errors
        setErrors({
            reportName: '',
            category: '',
            newGroupName: '',
            providerName: '',
            hospitalName: '',
            reportDate: ''
        });

        // Only Report Name is mandatory
        let hasErrors = false;
        const newErrors = {};

        if (!editedData.ReportName) {
            newErrors.reportName = "Report Name is required.";
            hasErrors = true;
        }

        // If there are any errors, set them and return early
        if (hasErrors) {
            setErrors(newErrors);
            return;
        }

        if (onSave) {
            setIsSaving(true);
            setSaveError('');
            try {
                const res = await dispatch(updateMRSItesReports(editedData));
                console.log("res", res)
                onSave(res);
                onHide();
            } catch (error) {
                console.log("err", error)
                setSaveError(error.message || "Failed to save changes");
            } finally {
                setIsSaving(false);
            }
        }
    };

    if (!show) return null;

    return (
        <div className="custom-modal-overlay">
            <div className="custom-modal_edit_report">
                <div className="custom-modal-header">
                    <span className="modal-title">
                        Edit Report Details
                        {reportData?.contact_name && (
                            <span className="modal-user-name">
                                {reportData.contact_name}
                            </span>
                        )}
                    </span>
                    <span className="close-btn" onClick={onHide}>&times;</span>
                </div>
                <div className="custom-modal-body">
                    <div className="form-group">
                        <label>Report Name: <span className="text-danger" title="This field is required" style={{ cursor: 'help' }}>*</span> </label>
                        <input
                            className="form-control"
                            value={reportName}
                            onChange={(e) => handleInputChange('report_name', e.target.value)}
                        />
                        {errors.reportName && (
                            <div style={{ color: 'red', fontSize: '12px', marginTop: '5px', fontWeight: 'bold' }}>
                                {errors.reportName}
                            </div>
                        )}
                    </div>
                    <div className="form-group">
                        <label>Report Type:</label>
                        {!isAddingNewGroup ? (
                            <>
                                <select
                                    className="form-control select-group"
                                    value={category}
                                    onChange={(e) => handleInputChange('group_name', e.target.value)}
                                >
                                    <option value="" disabled>Select a type...</option>
                                    {groupsLst.map((group) => (
                                        <option key={group.id} value={group.id}>
                                            {group.category}
                                        </option>
                                    ))}
                                </select>
                                <a
                                    href="#"
                                    className="add-new-link"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setIsAddingNewGroup(true);
                                        clearFieldError('category');
                                    }}
                                >
                                    Report Type not found? Please click here to add New
                                </a>
                                {errors.category && (
                                    <div style={{ color: 'red', fontSize: '12px', marginTop: '5px', fontWeight: 'bold' }}>
                                        {errors.category}
                                    </div>
                                )}
                            </>
                        ) : (
                            <div>
                                <input
                                    className="form-control new-group-input"
                                    placeholder="Enter new report type"
                                    value={newGroupName}
                                    onChange={(e) => {
                                        setNewGroupName(e.target.value);
                                        clearFieldError('newGroupName');
                                    }}
                                />
                                {errors.newGroupName && (
                                    <div style={{ color: 'red', fontSize: '12px', marginTop: '5px', fontWeight: 'bold' }}>
                                        {errors.newGroupName}
                                    </div>
                                )}
                                <div className="btn-group">
                                    <button
                                        className="btn-link_edit_report save"
                                        onClick={addNewGroup}
                                    >
                                        Save
                                    </button>
                                    <button
                                        className="btn-link_edit_report cancel"
                                        onClick={() => {
                                            setIsAddingNewGroup(false);
                                            setNewGroupName('');
                                            clearFieldError('newGroupName');
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="form-group">
                        <label>Provider Name:</label>
                        <input
                            className="form-control"
                            value={providerName}
                            onChange={(e) => handleInputChange('provider_name', e.target.value)}
                        />
                        {errors.providerName && (
                            <div style={{ color: 'red', fontSize: '12px', marginTop: '5px', fontWeight: 'bold' }}>
                                {errors.providerName}
                            </div>
                        )}
                    </div>
                    <div className="form-group">
                        <label>Clinic / Diagnostics Center Name:</label>
                        <input
                            className="form-control"
                            value={hospitalName}
                            onChange={(e) => handleInputChange('hospital_name', e.target.value)}
                        />
                        {errors.hospitalName && (
                            <div style={{ color: 'red', fontSize: '12px', marginTop: '5px', fontWeight: 'bold' }}>
                                {errors.hospitalName}
                            </div>
                        )}
                    </div>
                    <div className="form-group">
                        <label>Report Date:</label>
                        <Flatpickr
                            value={reportDate}
                            onChange={(date) => handleInputChange('report_date', date)}
                            options={{
                                dateFormat: "m/d/Y",
                                maxDate: new Date(),
                            }}
                            className="form-control"
                        />
                        <span
                            style={{ position: "absolute", right: "10px", top: "30px" }}
                            onClick={() => document.querySelector(".flatpickr-input").focus()}
                        >
                            <Calendar size={20} style={{ color: "#ffff" }} />
                        </span>
                        {errors.reportDate && (
                            <div style={{ color: 'red', fontSize: '12px', marginTop: '5px', fontWeight: 'bold' }}>
                                {errors.reportDate}
                            </div>
                        )}
                    </div>
                </div>
                <div className="custom-modal-footer">
                    <div className="d-flex justify-content-center gap-2 mt-3">
                        <button
                            className="btn_edit_report btn-primary"
                            onClick={handleSaveChanges}
                            disabled={isSaving}
                        >
                            {isSaving ? 'Saving...' : 'Save'}
                        </button>
                        <button
                            className="btn_edit_report btn-danger"
                            onClick={onHide}
                            disabled={isSaving}
                        >
                            Close
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default EditReportModal;
